import { create } from 'zustand';

interface DropDownOpenStore {
    rowsOpen: { [key: number]: boolean }; // Object with accountId as keys and boolean values for open/close state
    setRowOpen: (accountId: number, open: boolean) => void; // Function to toggle row open/close
    clearRows: () => void;
}

// Create the Zustand store
const dropDownStore = create<DropDownOpenStore>((set) => ({
    rowsOpen: {}, // Initialize with an empty object
    setRowOpen: (accountId: number, open: boolean) =>
        set((state) => ({
            rowsOpen: { ...state.rowsOpen, [accountId]: open }, // Update the specific accountId
        })),
    clearRows: () => set({ rowsOpen: {} }),
}));

export default dropDownStore;
